import axios from "axios";

// Always use the current browser origin in the browser, so calls from both
// https://catt.center and https://www.catt.center stay same-origin (no CORS).
// Fall back to REACT_APP_BACKEND_URL only when there is no window (SSR/tests).
const BROWSER_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = BROWSER_ORIGIN || process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  timeout: 30000,
});

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const fetchStats = () => api.get("/stats").then((r) => r.data);
